/**
 * @description Describes Metrics
 */
export enum Metrics {
	/**
	 * @description Measures the time it takes to load Smart Tag Skin and any ad sdks Smart Tag preloads instead of avia
	 * <p>i.e. desktop: DAI SDK</p>
	 * @type {Metrics.importsLoadTime}
	 */
	importsLoadTime = 'SmartTag.importsLoadTime',

	/**
	 * @description Measures the time it takes to load avia and any VTG plugin scripts
	 * @type {Metrics.aviaLoadTime}
	 */
	aviaLoadTime = 'SmartTag.aviaLoadTime',

	/**
	 * @description Measures the time it takes from Smart Tag script fully loaded to <code>SmartTag.create( params )</code>
	 * @type {Metrics.importToCreateTime}
	 */
	importToCreateTime = 'SmartTag.importToCreateTime',

	/**
	 * @description Measures the time it takes from <code>SmartTag.create( params )</code> to <code>tag.API.VIDEO.load( params )</code>
	 * @type {Metrics.createToLoadTime}
	 */
	createToLoadTime = 'SmartTag.tag.createToLoadTime',

	/**
	 * @description Measures the time it takes from <code>tag.API.VIDEO.load( params )</code> to <code>player.attachResource( resource ) </code>
	 * @type {Metrics.loadToAttachResourceTime}
	 */
	loadToAttachResourceTime = 'SmartTag.tag.loadToAttachResourceTime',

	/**
	 * @description Measures the tie it takes from <code>player.attachResource( resource ) </code> to <code>PlayerAdapterEvent.PLAYBACK_STARTED</code>
	 * @type {Metrics.attachToVideoStartTime}
	 */
	attachToVideoStartTime = 'SmartTag.tag.attachToVideoStartTime',

}